"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconPhoneSvg = function IconPhoneSvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.29.442C1.264 1.467.23 2.86 0 4.18c.035 2.766 2.44 5.77 5.22 8.548 1.377 1.376 2.868 2.76 4.339 3.765 1.47 1.006 2.933 1.68 4.33 1.468 1.232-.134 2.75-1.43 3.672-2.297.608-.61.562-1.742 0-2.322l-2.342-2.34c-.723-.598-1.661-.57-2.42-.19l-1.573 1.157c-.395.141-.844-.214-1.114-.406-.636-.454-1.367-1.166-1.954-1.753-.597-.596-1.32-1.283-1.771-1.89-.297-.381-.483-.79-.38-1.184.393-.544.811-1.096 1.192-1.64.344-.77.333-1.763-.207-2.323L4.658.45C3.856-.19 3.068-.107 2.29.442zm1.59.785L6.205 3.56c.208.333.128.656.018 1.01L5.116 6.08c-.514.907-.144 1.79.38 2.504.548.737 1.31 1.428 1.885 2.003.588.588 1.329 1.344 2.082 1.882.7.495 1.685.876 2.42.389.5-.37 1.003-.737 1.504-1.105.388-.154.703-.147 1.054.034l2.334 2.331c.17.267.137.47.017.743-.972.724-1.97 1.794-3.076 2.012-.904.133-2.17-.362-3.535-1.295-1.37-.937-2.82-2.273-4.174-3.627-2.691-2.688-4.833-5.655-4.892-7.736.164-.84.888-1.858 1.936-2.97.306-.231.522-.167.83-.018z"
  }));
};

IconPhoneSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
};

var IconPhone = function IconPhone(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray800' : _ref$color,
      measure = _ref.measure,
      rest = _objectWithoutProperties(_ref, ["color", "measure"]);

  return /*#__PURE__*/_react.default.createElement(_index.IconStyled, _extends({
    $color: color,
    $measure: measure
  }, rest), /*#__PURE__*/_react.default.createElement(IconPhoneSvg, null));
};

IconPhone.displayName = 'IconPhone';
var _default = IconPhone;
exports.default = _default;